/**
 * Shared "slide in on hover" styling for row-level Resolve/Review actions, used by both the generic
 * table row (see ResolveRowOverlay in TimestampLinks.tsx) and CollaborationDetectedEventRow, so both
 * reveal the same way when their ancestor row is hovered or holds focus.
 */

export const RESOLVE_REVEAL_TRANSITION_MS = 180;
export const RESOLVE_REVEAL_CLASS = "resolve-reveal";
/** Class on a cell's normal content (e.g. the flag badge) that fades out when the button reveals. */
export const RESOLVE_REVEAL_HIDE_CLASS = "resolve-reveal-hide";

/**
 * Applied to the event row. Mirrors rowSelectHoverSx in reports/shared/report-components.tsx, with
 * focus-within added: there the revealed button can sit at tabIndex -1 because activating the row
 * does the same thing, but here the row's own click seeks the video instead, so Resolve stays a real
 * tab stop — and has to reveal when it takes focus, not just on hover.
 */
export const resolveRevealHoverSx = {
	[`&:hover .${RESOLVE_REVEAL_CLASS}, &:focus-within .${RESOLVE_REVEAL_CLASS}`]: {
		opacity: 1,
		transform: "translateX(0)",
		pointerEvents: "auto",
	},
	[`&:hover .${RESOLVE_REVEAL_HIDE_CLASS}, &:focus-within .${RESOLVE_REVEAL_HIDE_CLASS}`]: {
		opacity: 0,
	},
};

/**
 * Base "hidden, slid right" state for an element carrying {@link RESOLVE_REVEAL_CLASS}. Positioning is
 * left to the caller: ResolveRowOverlay overlays a fixed-width column absolutely, while
 * CollaborationDetectedEventRow's button sits inline in a flex row instead.
 */
export const resolveRevealBaseSx = {
	opacity: 0,
	transform: "translateX(24px)",
	pointerEvents: "none" as const,
	willChange: "opacity, transform",
	backfaceVisibility: "hidden" as const,
	transition: `opacity ${RESOLVE_REVEAL_TRANSITION_MS}ms ease-out, transform ${RESOLVE_REVEAL_TRANSITION_MS}ms cubic-bezier(0.22,0.8,0.3,1)`,
};
